(function () {
  function syncRow(nativeItem, row, currentLabel, labelCurrent) {
    var unavailable = nativeItem.classList.contains('is--soldout') || nativeItem.classList.contains('is--unavailable');
    row.classList.toggle('is-unavailable', unavailable);

    var selected = nativeItem.classList.contains('is--selected');
    row.classList.toggle('is-active', selected);

    var check = row.querySelector('.loove-dd__check');
    if (selected && !check) {
      check = document.createElement('span');
      check.className = 'loove-dd__check';
      check.setAttribute('aria-hidden', 'true');
      row.appendChild(check);
    } else if (!selected && check) {
      check.remove();
    }

    if (selected) {
      var value = row.getAttribute('data-value');
      if (currentLabel) currentLabel.textContent = value;
      if (labelCurrent) labelCurrent.textContent = ' : ' + value;
    }
  }

  function initDD(dd) {
    var nativeWrapper = document.getElementById(dd.getAttribute('data-native-id'));
    if (!nativeWrapper) return;

    var trigger = dd.querySelector('[data-loove-dd-trigger]');
    var panel = dd.querySelector('[data-loove-dd-panel]');
    var currentLabel = dd.querySelector('[data-loove-dd-current]');
    var labelCurrent = dd.querySelector('.loove-dd__label-current');

    dd.querySelectorAll('[data-loove-dd-row]').forEach(function (row) {
      var value = row.getAttribute('data-value');
      var nativeItem = nativeWrapper.querySelector('[data-swatch-item][data-value="' + CSS.escape(value) + '"]');
      if (!nativeItem) return;

      syncRow(nativeItem, row, currentLabel, labelCurrent);

      new MutationObserver(function () {
        syncRow(nativeItem, row, currentLabel, labelCurrent);
      }).observe(nativeItem, { attributes: true, attributeFilter: ['class'] });

      row.addEventListener('click', function () {
        if (row.classList.contains('is-unavailable')) return;
        nativeItem.click();
        panel.setAttribute('hidden', '');
        trigger.setAttribute('aria-expanded', 'false');
        dd.classList.remove('is-open');
      });
    });

    trigger.addEventListener('click', function () {
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!isOpen));
      dd.classList.toggle('is-open', !isOpen);
      panel.toggleAttribute('hidden', isOpen);
    });
  }

  document.querySelectorAll('[data-loove-dd]').forEach(initDD);
})();
